import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type AvailableCarrierServiceFragmentFragment = { __typename?: 'AvailableCarrierService', carrier: Types.OpsOrderCarrier, services: Array<Types.OpsOrderCarrierService> };

export const AvailableCarrierServiceFragmentFragmentDoc = gql`
    fragment AvailableCarrierServiceFragment on AvailableCarrierService {
  carrier
  services
}
    `;